import type { ID, Service } from "@App/types";

/**
 * A labelled section of the service selection, ready to render.
 */
export type ServiceGroup = {
  label: string;
  services: Service[];
};

/**
 * Which services belong under which label, keyed by service id.
 */
export type ServiceGroupDefinition = {
  label: string;
  serviceIds: ID[];
};

/**
 * Resolves group definitions against the services a whitelabel actually has.
 */
export const groupServices = (
  services: Service[],
  definitions: ServiceGroupDefinition[],
  restLabel: string,
): ServiceGroup[] => {
  const claimed = new Set<Service>();

  const groups = definitions
    .map(({ label, serviceIds }) => ({
      label,
      services: serviceIds
        .map((id) => services.find((service) => String(service.id) === String(id)))
        .filter((service): service is Service => service !== undefined && !claimed.has(service))
        .map((service) => {
          claimed.add(service);
          return service;
        }),
    }))
    .filter((group) => group.services.length > 0);

  const rest = services.filter((service) => !claimed.has(service));

  return rest.length > 0 ? [...groups, { label: restLabel, services: rest }] : groups;
};
